// Ed25519 SSH key generation via micro-key-producer (pure JS, by the @noble author).
// Produces a real OpenSSH private key block and an `ssh-ed25519 ...` public line.
// The 32-byte seed comes from the Web Crypto CSPRNG — nothing is sent anywhere.
import sshKeygen from 'micro-key-producer/ssh.js';
import { randomBytes } from './random';
import type { SshKeyPair } from './ssh-types';

export function generateEd25519KeyPair(comment: string): SshKeyPair {
  const seed = randomBytes(32);
  const key = sshKeygen(seed, comment);
  return {
    type: 'ed25519',
    publicKey: key.publicKey.trim(),
    privateKey: key.privateKey,
    fingerprint: key.fingerprint,
    privateFilename: 'id_ed25519',
    publicFilename: 'id_ed25519.pub',
  };
}
